import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AverageCourseFeedbackQueryVariables = Types.Exact<{
  input: Types.CourseFeedbacksInput;
}>;


export type AverageCourseFeedbackQuery = { __typename?: 'Query', AverageCourseFeedback?: number | null };


export const AverageCourseFeedbackDocument = gql`
    query AverageCourseFeedback($input: CourseFeedbacksInput!) {
  AverageCourseFeedback(input: $input)
}
    `;

/**
 * __useAverageCourseFeedbackQuery__
 *
 * To run a query within a React component, call `useAverageCourseFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageCourseFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageCourseFeedbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAverageCourseFeedbackQuery(baseOptions: Apollo.QueryHookOptions<AverageCourseFeedbackQuery, AverageCourseFeedbackQueryVariables> & ({ variables: AverageCourseFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AverageCourseFeedbackQuery, AverageCourseFeedbackQueryVariables>(AverageCourseFeedbackDocument, options);
      }
export function useAverageCourseFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AverageCourseFeedbackQuery, AverageCourseFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AverageCourseFeedbackQuery, AverageCourseFeedbackQueryVariables>(AverageCourseFeedbackDocument, options);
        }
export type AverageCourseFeedbackQueryHookResult = ReturnType<typeof useAverageCourseFeedbackQuery>;
export type AverageCourseFeedbackLazyQueryHookResult = ReturnType<typeof useAverageCourseFeedbackLazyQuery>;
export type AverageCourseFeedbackQueryResult = Apollo.QueryResult<AverageCourseFeedbackQuery, AverageCourseFeedbackQueryVariables>;